<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    setName: string
    hasConfigurator?: boolean
  }>(),
  {
    setName: '',
    hasConfigurator: false,
  }
)

const keys = [
  props.setName,
  'parameters',
  'configurator',
  'variants',
  'files',
  'gallery',
  'references',
  'surfaces',
  'accessories',
]
const nonEmptySections = ref<string[]>(keys)

let observer: MutationObserver
function updateTabMenu() {
  const foundSections = keys.filter((key) => document.getElementById(key))
  foundSections.push(props.setName)
  if (foundSections.length > 1) {
    nonEmptySections.value = foundSections
  }
}

onMounted(() => {
  observer = new MutationObserver(() => {
    updateTabMenu()
  })
  observer.observe(document.getElementById('setContent') ?? document.body, {
    childList: true,
    subtree: true,
  })
  updateTabMenu()
})

onBeforeUnmount(() => {
  if (observer) {
    observer.disconnect()
  }
})

const tabs = computed(() => {
  return keys
    .filter((key) => nonEmptySections.value.includes(key))
    .map((key, index) => ({
      key,
      title: index ? 'base.products.tabs.' + key : key,
    }))
})
</script>

<template>
  <UiNavMenu :tabs="tabs" />
</template>
